import { AxiosRequestConfig } from 'axios';
import { apiClient } from './client';
import { withMultipartAuthorizationHeader } from './auth';
import { UploadedImage } from '../domain/images';

export const uploadImage = async (
  token: string,
  formData: FormData,
  opts: AxiosRequestConfig = {},
): Promise<UploadedImage> => {
  const res = await apiClient.post<UploadedImage>(
    '/v1/uploads',
    formData,
    withMultipartAuthorizationHeader(token, opts),
  );
  return res.data;
};
